import { useCallback, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import IconButton from 'LuxKit/Button/IconButton'
import LineEllipsisVIcon from 'LuxKit/Icons/line/LineEllipsisVIcon'
import DropdownList from 'LuxKit/Dropdown/List/DropdownList'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import LineTrashAltIcon from 'LuxKit/Icons/line/LineTrashAltIcon'
import LineCalendarAltIcon from 'LuxKit/Icons/line/LineCalendarAltIcon'
import noop from 'lib/function/noop'

interface Props {
  onDelete?: () => void
  onAddToTrip?: () => void
}

function ChatItemDropdown(props: Props) {
  const intl = useIntl()
  const { onDelete = noop, onAddToTrip } = props
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const dropdownTriggerRef = useRef<HTMLButtonElement>(null)

  const toggleDropdown = useCallback(() => {
    setIsDropdownOpen(prev => !prev)
  }, [])

  const closeDropdown = useCallback(() => {
    setIsDropdownOpen(false)
  }, [])

  const handleDelete = useCallback(() => {
    closeDropdown()
    onDelete()
  }, [closeDropdown, onDelete])

  const handleAddToTrip = useCallback(() => {
    closeDropdown()
    onAddToTrip?.()
  }, [closeDropdown, onAddToTrip])

  return (
    <>
      <IconButton
        size="small"
        kind="tertiary"
        onClick={toggleDropdown}
        ref={dropdownTriggerRef}
      >
        <LineEllipsisVIcon />
      </IconButton>
      <DropdownList
        size="S"
        open={isDropdownOpen}
        onClose={closeDropdown}
        triggerRef={dropdownTriggerRef}
        anchorRef={dropdownTriggerRef}
      >
        {onAddToTrip && (
          <ClickableListItem
            title={intl.formatMessage({
              id: 'sscpRc54E54WtBIXCi07',
              defaultMessage: 'Reschedule stay',
              description: 'Dropdown menu item to reschedule an accommodation stay in the itinerary',
            })}
            size="medium"
            startIcon={<LineCalendarAltIcon size="S" />}
            onClick={handleAddToTrip}
          />
        )}
        <ClickableListItem
          title={intl.formatMessage({
            id: 'e4B_Ms_37XNc8-2CIHTd',
            defaultMessage: 'Delete',
            description: 'Dropdown menu item to delete an item from the itinerary',
          })}
          size="medium"
          startIcon={<LineTrashAltIcon size="S" />}
          onClick={handleDelete}
        />
      </DropdownList>
    </>
  )
}

export default ChatItemDropdown
